import { FilterAggregation } from '@features/filters/filter-aggregation.interface';
import { Type } from 'class-transformer';
import { HitsRelation } from './hits-relation';
import { TotalHits } from './total-hits';

export class SearchResultInfo {
  aggregations: FilterAggregation[] = [];

  @Type(() => TotalHits)
  totalHits: TotalHits = {
    value: 0,
    relation: HitsRelation.Eq,
  };

  maxScore = 0;

  took = 0;

  nextPage: string;
}
